export default __webpack_public_path__ + "6ca7427bb74f46dac741644f927e6f93.png";